export default __webpack_public_path__ + "static/media/vkpic4.b189c1d8.png";